module.exports = __webpack_public_path__ + "img/gu.e229d7c0.svg";